export const replaceArrayValue = <T>(array: T[], index: number, newValue: T): T[] => [
	...array.slice(0, index),
	newValue,
	...array.slice(index + 1),
]

export function removeArrayIndex<T>(array: T[], index: number): T[] {
	return [...array.slice(0, index), ...array.slice(index + 1)]
}

export const toDistinctArray = <T>(array: T[]): T[] => [...new Set(array)]

export function toggleArrayItem<T>(array: T[], item: T): T[] {
	return array.includes(item) ? array.filter(i => i !== item) : [...array, item]
}
